(function() {
	document.addEventListener('DOMContentLoaded', () =>{
		const tabs = document.querySelectorAll('.tabbed-card-list__tab')
		const tabsButtons = document.querySelectorAll('.tabbed-card-list__tab button');
		const tabsSections = document.querySelectorAll('.tabbed-card-list__content-item');
		let parent = null;
		tabsButtons.forEach((button, index) => {
			button.addEventListener('click', (e) => {
				parent = button.parentNode.parentNode.parentNode.classList[0];
				tabsButtons.forEach(tabButton => {
					if (tabButton.parentNode.parentNode.parentNode.classList[0] == parent) {
						tabButton.classList.remove('current');
					}
				});
				button.classList.add('current');
				tabsSections.forEach(section => {
					if (section.parentNode.classList[1] == parent) {
						if (section.classList.contains('visible')) {
							section.classList.add('fadeOut');
							setTimeout(function() {
								section.classList.remove('visible');
							section.classList.remove('fadeOut');
							}, 200)
						}
					}
				});
				let tabTargetClass = button.classList[0];
				let tabTargetElement = document.querySelector(`.tabbed-card-list__content-item.${tabTargetClass}`)
				tabTargetElement.classList.add('fadeIn');
				setTimeout(function() {
					tabTargetElement.classList.add('visible');
					tabTargetElement.classList.remove('fadeIn');
				}, 400);
			});
		});
	})
})();